import { render, staticRenderFns } from "./SamSidebarManager.vue?vue&type=template&id=11c5345a&"
import script from "./SamSidebarManager.vue?vue&type=script&lang=js&"
export * from "./SamSidebarManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports